import { CssBaseline } from '@mui/material'
import { GamixterThemeProvider } from './Theme/ThemeContext';
import { Provider } from 'react-redux';
import store from './store';
import { RouteOnAuth } from './navigation/AdminRouter';

function GamixterAdminApp() {
  return (
    <GamixterThemeProvider>
      <CssBaseline />
      <Provider store={store}>
        <RouteOnAuth />
      </Provider>
    </GamixterThemeProvider>
  );
}

export default GamixterAdminApp;
